import { useEffect } from 'react';

const DEFAULT_TITLE = document.title;

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};

export default useDocumentTitle;
